import { Component, Inject, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CategoryAddAttributesModal} from './category-add-attributes-modal';

@Component({
  selector: 'app-cp-confirm-modal',
  templateUrl: './category-add-attributes-modal.component.html',
  styleUrls: ['./category-add-attributes-modal.component.scss'],
})
export class CategoryAddAttributesModalComponent implements OnInit {
  pending: boolean = false;
  retypeDeleteKeyword: boolean = false;

  public editFormGroup: FormGroup = this.fb.group({
    check: ['', []],
  });

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: CategoryAddAttributesModal,
    public matDialogRef: MatDialogRef<CategoryAddAttributesModalComponent>,
  ) {

  }

  ngOnInit(): void {

  }

  cancel() {
    if (this.data && this.data.cancelAction) {
      const promise: Promise<any> = this.data.cancelAction();
      promise.then((result) => {
        this.matDialogRef.close(false);
      });
    }
  }

  proceed() {
      if (this.data && this.data.proceedAction) {

        const promise: Promise<any> = this.data.proceedAction();
        promise.then((result) => {
          this.matDialogRef.close(true);
        });
      }
  }
}
